import React, { useContext, useEffect } from "react";

import { DataContext } from "../../../../../providers/ElectricityCheckoutDataProvider";
import { DataContext as DataContextCalculator } from "../../../../../providers/ElectricityDataProvider";
import paymentTypes from "../../../../../providers/PaymentTypes";
import {
    formattedToNumber,
    roundNumber,
} from "../../../../../utils/NumberHelpers";
import Campaign from "../../../../shared/Campaign";
import { navigate } from "../../../../shared/LinkComponent";
import Margin from "../../../../shared/Margin";
import Headline from "../../../../shared/NewHeadline";
import OrderChangableDetail from "../../../../shared/OrderChangableDetail";
import TextAlign from "../../../../shared/TextAlign";
import DeliveryAddress from "../StepDeliveryAddress/BaseDeliveryForm/DeliveryAddress";
import ContactData from "../StepDeliveryAddress/ContactData";
import StepPaymentType from "../StepPaymentType";
import Agb from "./Agb";
import Amount from "./Amount";
import ElectricityCalculatorResult from "./ElectricityCalculatorResult";
import ReceiveNewsletter from "./ReceiveNewsletter";
import * as styles from "./style.module.scss";

const StepOverview = () => {
    const dataContext = useContext(DataContext);
    const dataContextCalculator = useContext(DataContextCalculator);

    const {
        consumption,
        deliveryAddressData,
        paymentData,
        product,
        zipcode,
        street,
        houseNum,
        place,
    } = dataContext.data;

    const { setEditMode, setOverlayContent } = dataContext.actions;

    const { setLoading } = dataContextCalculator.actions;

    useEffect(() => {
        setLoading(true);
        // getPrices(verbandsnummer, 'null', '21339', '1500');
    }, []);

    return (
        <Margin Component={"section"} top="10">
            <Headline>Bestelldetails</Headline>

            <OrderChangableDetail
                label={product.tarifName}
                readOnly
                changeContent={<ElectricityCalculatorResult />}
                onOverlayInit={() => {
                    setOverlayContent("produkt");
                }}
                gtag="ele:checkout:overview:product"
                DataContext={DataContext}
            />

            <OrderChangableDetail
                label={`Bedarf ${consumption} kWh`}
                readOnly
                changeContent={<Amount />}
                onOverlayInit={() => {
                    setOverlayContent("consumption");
                }}
                gtag="ele:checkout:overview:consumption"
                DataContext={DataContext}
            />

            <OrderChangableDetail
                label={paymentTypes[paymentData.payment_payment_type - 1].name}
                readOnly
                changeContent={<StepPaymentType />}
                onOverlayInit={() => {
                    setOverlayContent("zahlart");
                }}
                gtag="ele:checkout:overview:payment-type"
                DataContext={DataContext}
            />

            <OrderChangableDetail
                label="Kontaktdaten"
                value={
                    <div>
                        {deliveryAddressData.salutation}{" "}
                        {deliveryAddressData.firstname}{" "}
                        {deliveryAddressData.lastname}
                        {deliveryAddressData.email && (
                            <React.Fragment>
                                <br /> {deliveryAddressData.email}
                            </React.Fragment>
                        )}
                        {deliveryAddressData.phone && (
                            <React.Fragment>
                                <br /> {deliveryAddressData.phone}
                            </React.Fragment>
                        )}
                    </div>
                }
                changeContent={<ContactData />}
                onOverlayInit={() => {
                    setOverlayContent("lieferadresse");
                }}
                gtag="ele:checkout:overview:contact"
                DataContext={DataContext}
            />

            <OrderChangableDetail
                label="Lieferadresse"
                value={
                    <div>
                        {String(street) + " " + String(houseNum)}
                        <br />
                        {zipcode} {place}
                    </div>
                }
                readOnly={true}
                onClick={() => {
                    setEditMode(true);
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    navigate("/strom/bestellung/lieferadresse");
                }}
                changeContent={<DeliveryAddress />}
                onOverlayInit={() => {
                    setOverlayContent("lieferadresse");
                }}
                gtag="ele:checkout:overview:delivery-address"
                DataContext={DataContext}
            />

            <Agb />

            <ReceiveNewsletter />
            <Campaign name="mitmachen2020">
                <Campaign.Content>
                    <TextAlign align="center" className={styles.totalAmount}>
                        Gesamtpreis:&nbsp;
                        <span
                            className={` ${styles.totalAmountValue} ${styles.lineThrough}`}
                        >
                            <span className={styles.blackText}>
                                {product.gesamtpreisOhneBoniBrutto}€
                            </span>
                        </span>
                    </TextAlign>
                    <TextAlign align="center" className={styles.reduction}>
                        Abzüglich:&nbsp;
                        <span className={` ${styles.reductionValue}`}>
                            -100,00€
                        </span>
                    </TextAlign>
                    <TextAlign align="center" className={styles.totalAmount}>
                        Gesamt:&nbsp;
                        <span className={` ${styles.totalAmountValue}`}>
                            {roundNumber(
                                formattedToNumber(
                                    product.gesamtpreisOhneBoniBrutto
                                ) - 100
                            )}
                            €
                        </span>
                    </TextAlign>
                </Campaign.Content>
                <Campaign.Fallback>
                    <div className={styles.totalPrice}>
                        Gesamtpreis: {product.gesamtpreisOhneBoniBrutto}
                        &nbsp;€
                    </div>
                </Campaign.Fallback>
            </Campaign>
        </Margin>
    );
};

export default StepOverview;
